module.exports = __webpack_public_path__ + "img/13 PORTRAIT.f27f0309.png";